import { FC } from "react";

import { ReportDiagramsInner } from "../diagrams";
import { ReportsWrapperDiagramStyled } from "../parts";

export const ReportsWrapperDiagrams: FC = () => {
  return (
    <ReportsWrapperDiagramStyled>
      <ReportDiagramsInner />
    </ReportsWrapperDiagramStyled>
  );
};
